import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getAssetHrCategories ({ page = 1, limit = 999 }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`, 'sort[]=name']
    return instCred.get(`hr/assetcategories?${query.join('&')}`)
  },
  createAssetHrCategory (category) {
    category.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('hr/assetcategories', category)
  },
  editAssetHrCategory (category) {
    category.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('hr/assetcategories/' + category.id, category)
  },
  deleteAssetHrCategory (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.delete('hr/assetcategories/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/HrAssetCategories/api.js